import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { MesesEnum } from '../dominios/enum/meses.enum';

/**
 * An utility service for date.
 */
@Injectable()
export class DateUtilService {

  private pattern = 'dd-MM-yyyy';

  private datePipe: DatePipe;


  constructor() {
    this.datePipe = new DatePipe('en');
  }

  /**
   * Method transfomar o mês numerico em alfabetico
   * Aqui existe um tratamento
   */
  public _formatData(dtReferencia: string): string {
    const mes = Number(dtReferencia.substr(0, 2))
    const ano = Number(dtReferencia.split('/')[1])
    return `${MesesEnum.getDescricao(mes)}/${ano}`
  }

  /**
  * Method transfomar o mês numerico em alfabetico
  */
  public _carregarDescricaoMesAno(mes: number, ano: number): string {
    return `${MesesEnum.getDescricao(mes)}/${ano}`;
  }

  // tslint:disable-next-line: member-ordering
  public dataToPt() {
    return {
      firstDayOfWeek: 0,
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
        'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoje',
      clear: 'Limpar'
    };
  }

  /**
   * Method to convert the date from server into JS date object
   */
  convertLocalDateFromServer(date: string): Date {
    if (date) {
      const dateString = date.replace('-', '.');
      // return new Date(Number(dateString[0]), Number(dateString[1]) - 1, Number(dateString[2]));
      const pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
      return new Date(dateString.replace(pattern, '$3-$2-$1'));
    }
    return null;
  }

  /**
   * Method to convert the JS date object into specified date pattern
   */
  convertLocalDateToServer(date: any, pattern = this.pattern) {
    if (date) {
      const newDate = new Date(date);
      return this.datePipe.transform(newDate, pattern);
    } else {
      return null;
    }
  }

  /**
   * Method to get the default date pattern
   */
  dateformat() {
    return this.pattern;
  }

  // TODO Change this method when moving from datetime-local input to NgbDatePicker
  toDate(date: any): Date {
    if (date === undefined || date === null) {
      return null;
    }
    const dateParts = date.split(/\D+/);
    if (dateParts.length === 7) {
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4], dateParts[5], dateParts[6]);
    }
    if (dateParts.length === 6) {
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4], dateParts[5]);
    }
    return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4]);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/date-util.service.ts